import { render, staticRenderFns } from "./Applicant.vue?vue&type=template&id=70a00d0f&scoped=true&"
import script from "./Applicant.vue?vue&type=script&lang=ts&"
export * from "./Applicant.vue?vue&type=script&lang=ts&"
import style0 from "./Applicant.vue?vue&type=style&index=0&id=70a00d0f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a00d0f",
  null
  
)

export default component.exports